
<div class="expansion-panel fund-details" *ngIf="details">
    <mat-accordion>
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                        <div class="w-100 mt-5">
                            <h4> Company Data</h4>
                            <hr>

                        </div>
    
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row mt-4">

                <div class="col-3">
                    <h5>English Name</h5>
                    <p>{{details.companyForm.nameEn}}</p>

                </div>
                <div class="col-3">
                    <h5>Arabic  Name</h5>
                    <p>{{details.companyForm.nameAr}}</p>

                </div>
                <div class="col-3">
                    <h5>Commercial Registration Number</h5>
                    <p>{{details.companyForm.commercialRegistrationNumber}}</p>
                </div>
                <div class="col-3">
                    <h5>Work Start Date</h5>
                    <p>{{details.companyForm.workStartDate}}</p>
                </div>
                <div class="col-3">
                    <h5>Tax Number</h5>
                    <p>{{details.companyForm.taxNumber}}</p>
                </div>
             
                <div class="col-3">
                    <h5>Paid Up Capital</h5>
                    <p>{{details.companyForm.paidUpCapital|numberWithCommas}}</p>
                </div>
                <div class="col-3">
                    <h5>Annualized Return</h5>
                    <p>{{details.companyForm.annualizedReturn|numberWithCommas}}</p>
                </div>
                <div class="col-3">
                    <h5>Employees Number</h5>
                    <p>{{details.companyForm.employeesNumber|numberWithCommas}}</p>
                </div>
             
                

            </div>
            <div class="w-100 mt-4">
                <hr>
                <div class="w-100  mt-5 d-flex align-items-center justify-content-between">
                    <h4> Company Files</h4>
                </div>
                <hr>
                </div>
                <div class="row first-panel">
                    <div *ngIf="details">
                       
                        <br>
                        <div class="row col-12 g-3">
                            <div class="col-3" *ngFor="let file of details.companyFiles;let i = index">
                            <div class="file-container" (click)="openFile(file.documentUrl)">                                                       
                                    <img  [src]="file.documentUrl" alt="Preview" onerror="this.src='../../../../../assets/image/Rectangle 2657 (1).png'">
                                    <div class="actions">
                                        <p>{{file.documentTypeNameEn}}</p>
                                    </div>
                            </div>
                            </div>
                        </div>
    
                    </div>
                </div>
        </mat-expansion-panel>
    </mat-accordion>
</div>


